<template>
  <div :class="$style.complete">
    <h3 :class="$style.complete__title">予約が完了しました</h3>
    <div :class="$style.complete__body">
      <p :class="$style.complete__datetime">予約日時: {{ bookingDateTime }}</p>
    </div>
    <div :class="$style.complete__actions">
      <FlatButton @click="handleClose"> 閉じる </FlatButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { computed } from 'vue'
import type { TimeSlot } from './TimeSlotPicker/useTimeSlot.ts'

const props = defineProps<{
  timeSlot: TimeSlot
}>()

const bookingDateTime = computed(() => {
  const startsAt = format(new Date(props.timeSlot.startsAt), 'y/M/d (E) H:mm', {
    locale: ja,
  })
  const endsAt = format(new Date(props.timeSlot.endsAt), 'H:mm', { locale: ja })
  return `${startsAt} 〜 ${endsAt}`
})

const handleClose = () => {
  window.close()
}
</script>

<style lang="scss" module>
.complete {
  padding: 24px;
  background-color: $color-surface-primary;
  border-radius: $border-radius-inner;

  &__title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 24px;
    color: $color-text-and-object-high-emphasis;
  }

  &__body {
    margin-bottom: 24px;
  }

  &__message {
    margin-bottom: 16px;
    font-size: 16px;
  }

  &__datetime {
    font-size: 18px;
    font-weight: bold;
    color: $color-text-and-object-accent-primary;
  }

  &__actions {
    display: flex;
    justify-content: flex-start;
  }
}
</style>
